import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/bookingActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch, showImportRatesToastr } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchBookingRates = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.B_RATES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.bookingRatesFind, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.b_fetchRatesSuccess(getParser(urls.bookingRates)(json))))
        .catch(
            handleError(
                dispatch,
                actions.b_fetchRatesFailure,
                'Что-то пошло не так!',
                'При получении тарифов произошла ошибка'
            )
        )
}

/** @thunk **/
export const postBookingRate = payload => (dispatch, getState) => {
    const { auth } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    }

    securedFetch(urls.bookingRates, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.b_saveRatesSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.b_saveRatesFailure,
                'Что-то пошло не так!',
                'При сохранении тарифов произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteBookingRate = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.bookingRateSelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.b_deleteRateSuccess(remoteId)))
        .then(() => toastr.success('Тариф удален'))
        .catch(
            handleError(
                dispatch,
                actions.b_deleteRateFailure,
                'Что-то пошло не так!',
                'При удалении тфрифа произошла ошибка'
            )
        )
}

/** @thunk **/
export const importBookingRates = () => (dispatch, getState) => {
    const { auth, bookingCurrentOrganization } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ organizationId: bookingCurrentOrganization })
    }

    securedFetch(urls.reloadRatesFromBooking, auth, opts)
        .then(handleResponse)
        .then(showImportRatesToastr)
        .then(json => dispatch(actions.b_importRatesSuccess(getParser(urls.reloadRatesFromBooking)(json))))
        .catch(
            handleError(
                dispatch,
                actions.b_importRatesFailure,
                'Что-то пошло не так!',
                'При импорте тарифов произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/bookingApi/bookingRates.js